import axios from "axios";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import bglogo from "../../../src/images/Technician-login/bglogo.png";
import NavbarT from "../../components/navbarTechnican";
import Loading from '../../loading';
import { login } from "../../redux/authSlice"; // Import the login action

const LoginTechnicianPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false); 
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const API_URL = process.env.REACT_APP_API_URL;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      // Make the API request
      const response = await axios.post(
        `${API_URL}/api/auth/login/technician`,
        { email, password }
      );

      // Destructure the response data
      const { token, technician } = response.data;

      // Ensure technician is defined
      if (!technician) {
        throw new Error("Technician not found in response");
      }

      // Check if the technician is blocked
      if (technician.isBlocked) {
        alert("Technician is blocked. Please contact support for assistance.");
        return;
      }

      // Dispatch login action using the role from the backend
      dispatch(login({ token, user: technician, role: technician.role }));

      // Store in local storage with expiration
      const expirationTime = Date.now() + 24 * 60 * 60 * 1000; // 24 hours in milliseconds
      localStorage.setItem("authToken", token);
      localStorage.setItem("authUser", JSON.stringify(technician));
      localStorage.setItem("authExpiration", expirationTime);

      // Navigate to dashboard
      navigate("/technician-dashboard");
    } catch (err) {
      if (err.response) {
        console.error("Login error:", err.response.data);
        alert(err.response.data.msg || "Login failed");
      } else {
        console.error("Login error:", err);
        alert("Login failed");
      }
    } finally {
      setLoading(false); // Stop loading after the try/catch
    }
  };

  return (
    <div className="relative h-screen bg-Tbanner bg-cover bg-center overflow-hidden font-clash">
      <NavbarT />
      <div className="flex flex-col lg:flex-row justify-center items-center h-full  lg:mt-20">
        {/* Left Side Text */}
        <div className="w-full lg:w-1/2 flex justify-center items-center mb-8 lg:mb-32 text-center">
          <div>
            <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white mb-4">
              Welcome to our team
            </h1>
            <hr className="bg-[#F0FFC5] h-[2px] w-40 sm:w-64 lg:w-[400px] mx-auto mb-4" />
            <p className="text-lg sm:text-xl text-white font-semibold">
              Your dedication makes this platform
            </p>
          </div>
        </div>

        {/* Right Side Login Form */}
        <div className="w-[350px] lg:w-1/3 bg-transparent py-8 px-6 sm:py-12 sm:px-10 shadow-lg rounded-2xl border border-[#F0FFC5] mb-8 lg:mb-24 backdrop-blur-lg">
          <form onSubmit={handleSubmit} className="backdrop-blur-lg">
            <div className=" mb-8">
              <label
                className=" ml-2    text-[#F0FFC5] font-semibold px-1"
                htmlFor="email"
              >
                Email
              </label>
              <input
                type="email"
                id="email"
                className="border rounded-3xl w-full py-3 mt-3 px-3 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] text-[#F0FFC5]"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div className=" mb-4">
              <label
                className="ml-2 text-[#F0FFC5] font-semibold px-1 focus:bg-transparent active:bg-transparent"
                htmlFor="password"
              >
                Password
              </label>
              <input
                type="password"
                id="password"
                className="border rounded-3xl mt-3 w-full py-3 px-3 bg-transparent text-[#F0FFC5] border-[#F0FFC5] focus:outline-none focus:ring-2 active:bg-transparent focus:ring-[#F0FFC5] focus:bg-transparent"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
            {loading ? (
            <div>
              <Loading />
            </div>
            ) : (
            <button
              type="submit"
              className="bg-transparent border border-[#F0FFC5] text-[#F0FFC5] font-bold mt-6 py-2 px-6 rounded-3xl w-full sm:w-auto"
              disabled={loading}
            >
              Sign in
            </button>
            )}
          </form>
        </div>
      </div>
      {/* Background logo positioned at the bottom */}
      <img
        src={bglogo}
        alt="background logo"
        className="absolute bottom-0 left-0 w-full h-[100px] sm:h-[150px] lg:h-[190px] object-contain"
      />
    </div>
  );
};

export default LoginTechnicianPage;
